import { Button, Modal } from "antd";
import { PERMISSIONS, useAuthorization } from "features/permissions";
import styled from "styled-components";

const StyledSpan = styled.span`
  margin: 0px 6px;
`;

const StyledDiv = styled.div`
  margin-bottom: 16px;
`;

function SelectAddAccountsModeModal({ title, open, onOk, onCancel }) {
  const { data: isAccountAddAuthorized } = useAuthorization(PERMISSIONS.ACCOUNT__CREATE);

  const modalFooter = [
    <Button key="cancel" onClick={onCancel}>
      Cancel
    </Button>,
  ];

  return (
    <Modal
      maskClosable={false}
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      footer={modalFooter}
      width={600}
    >
      <>
        <StyledDiv>What type of account do you want to add?</StyledDiv>
        {isAccountAddAuthorized && (
          <>
            <Button type="primary" onClick={() => onOk(true)}>
              Consumer
            </Button>
            <StyledSpan>or</StyledSpan>
            <Button onClick={() => onOk(false)}>Commercial</Button>
          </>
        )}
      </>
    </Modal>
  );
}

export default SelectAddAccountsModeModal;
